<template>
    <CRow>
        <CCol col>
            <div class="omi-price-padding"></div>
            <ejs-datepicker ref="dateObj" :placeholder="waterMark" v-model="dateVal" :format="dateFormat" :focus='onFocus' :firstDayOfWeek='1' :max='maxVal' width=180>
            </ejs-datepicker>
            <div style="width:100%; height: 80vh;">
                <ejs-grid ref='grid' :dataSource="otherMarketPricingData" :allowFiltering='true' :allowPaging="true" :allowResizing='true'
                          :toolbarClick='toolbarClick' :allowExcelExport='true' :excelExportComplete='excelExportComplete'
                          :allowReordering='true' :allowSorting='true' :editSettings='editSettings' :toolbar='toolbar'
                          :pageSettings='pageSettings' :actionBegin='actionBegin' :actionComplete='actionComplete' 
                          :actionFailure="actionFailure" :query='query' :filterSettings='filterOptions' width="100%" height="100%">
                    <e-columns>
                        <e-column field='id' headerText='Id' width=120 :isPrimaryKey='true' :visible='false'></e-column>
                        <e-column field='ricName' headerText='Identifier' textAlign='Left' width=120></e-column>
                        <e-column field='description' headerText='Description' textAlign='Left' width=300></e-column>
                        <e-column field='utilityTypeName' headerText='Category' textAlign='Left' width=150></e-column>
                        <e-column field='periodTypeName' headerText='Period Type' textAlign='Left' width=150></e-column>
                        <e-column field='periodCodeType' headerText='Period Code' type="number" textAlign='Left' width=150></e-column>
                        <e-column field='universalClosePriceDate' headerText='Settlement Date' :format='dateFormatOptions' textAlign='Left' width=180></e-column>
                        <e-column field='price' headerText='Settlement Price' type="number" format="n3" textAlign='Left' width=180></e-column>
                        <e-column field='tradingUnitPreview' headerText='Trading Unit' textAlign='Left' width=150></e-column>
                        <e-column field='date' headerText='Import Date' :format='dateFormatOptions' textAlign='Left' width=150></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
                <div id="modalTargetOther" class="control-section; position:relative" style="height:350px;">
                    <ejs-uploader ref="uploadObj" id='defaultfileupload' name="UploadFiles" :allowedExtensions="extensions" :uploading="addHeaders" :asyncSettings="path" :success="onUploadSuccess" :failure="onUploadFailed" :multiple='multiple'></ejs-uploader>
                </div>
        </CCol>
    </CRow>
</template>
<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { Query } from '@syncfusion/ej2-data';
    import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
    import authToken from '../../common/authToken';
    import urls from '../../common/urls'
    import dates from '../../common/dates'
    import SyncHelper from '../../common/syncfusion';
    import gridOptions from '../../common/gridOptions'
    import { DatePickerPlugin, DatePicker } from '@syncfusion/ej2-vue-calendars';
    import apis from '../../common/network';
    import store from '../../store';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';

    Vue.use(DatePickerPlugin);
    Vue.use(UploaderPlugin);
    Vue.use(GridPlugin);

    export default {
        components: {
        },
        data() {
            return {
                store: store,
                maxVal: new Date(),
                multiple: false,
                dateVal: dates.addDays(new Date(), -1),
                waterMark: 'Select a date',
                format: "dd/MM/yyyy",
                dateFormat: 'dd/MM/yyyy',
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy', max: new Date(), params: { max: new Date() } },
                path: {
                    saveUrl: `${urls.apiBaseUrl}otherMarketInstruments/Import/`
                },
                extensions: ' .xls, .xlsx',
                otherMarketPricingData: SyncHelper.getDataManager("otherMarketInstruments"),
               
                pageSettings: { pageSizes: [10, 20, 50, 100], pageSize: 100, pageCount: 4 },
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: false,
                    allowAdding: false,
                    allowDeleting: false,
                    mode: 'Dialog'
                },
                toolbar: ['ExcelExport'],
                editparams: { params: { popupHeight: '300px' } },
                filterOptions: gridOptions.filterSettings
            };
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
            this.checkPermissionOnUser();
        },
        methods: {
            checkPermissionOnUser: function () {

                if (!this.$store.state.permissions["Permissions.MarketWidgetsAndGraphs.Update"]) {

                        this.toolbar = ['Add', 'Edit', 'Delete'];
                        document.getElementById("modalTargetOther").style.display = "none";
                    }
       
            },
            toolbarClick(args) {
                gridOptions.excelExport(args, "Other Market Instruments Pricing.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
            },
            actionBegin(args) {
                gridOptions.actionBegin(args);
                if (args.requestType == 'save') {
                    showSpinner(document.getElementById('mainSpinner'));

                }
                if (args.requestType == 'refresh') {
                    hideSpinner(document.getElementById('mainSpinner'));


                }
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            },
            onUploadSuccess: function (args) {
                this.$refs.grid.refresh();
            },
            onUploadFailed: function (args) {
                this.$refs.grid.refresh();
                var statusMessage = JSON.parse(args.e.currentTarget.response).message;
                args.statusText = statusMessage.trim();
            },
            addHeaders: function (args) {
                args.currentRequest.setRequestHeader('Authorization', `Bearer ${authToken.get()}`);
            },
            onFocus: function (args) {
                this.$refs.dateObj.show();
            },
        },
        computed: {
            query: function () {
                this.dateVal;

                return new Query().addParams("date", this.dateVal.toISOString().split('T')[0]);
            }
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    };
</script>
<style scoped>
    .omi-price-padding {
        padding-top: 30px;
    }
</style>
